import { ApiAction, initialPaginatedApiState, PaginatedApiState } from '../../utils/requestAction'
import requestReducer from '../requestReducer'
import ProductBrand from '../../models/ProductBrand'

export interface ProductBrandListState extends PaginatedApiState {
  productBrands?: ProductBrand[] 
}

const ProductBrandList = (state: ProductBrandListState = initialPaginatedApiState, action: ApiAction) => {
  switch (action.type) {
    default:
      return requestReducer<ProductBrandListState>('PRODUCTBRAND_LIST')(state, action)
  }
}

export default ProductBrandList
